import $ from "jquery";

export const clickablePlateHandler = function (event) {
    event.preventDefault();

    const link = $(this).find('.plate__title a');

    if (link.length === 0)
        return;

    let linkUrl = link.attr('href');

    if ($(event.target).is('.plate__comment-icon')) {
        linkUrl += '#comments';
    }

    window.location.href = linkUrl;

    return false;
};

const clickablePlateHashtagHandler = function (event) {
    event.preventDefault();

    if ($(this).attr('href') !== undefined) {
        window.open($(this).attr('href'), '_blank');

        return false;
    }

    const link = $(this).find('a');

    window.open(link.attr('href'), '_blank');

    return false;
};

export const bindHandlerToPlates = () => {
    const plates = $('.plate-material');
    plates.unbind('click');
    plates.bind('click', clickablePlateHandler);

    const related = $('.related-materials-in-content__item-wrapper');
    related.unbind('click');
    related.bind('click', clickablePlateHashtagHandler);
};
